import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { OrderModel } from '../model/orderModel';

export const exportOrdersToExcel = (orders: OrderModel[]) => {
  if (!orders || orders.length === 0) {
    alert('No orders available to export.');
    return;
  }

  const data = orders.map((order) => ({
   OrderID: order.orderNumber?.[0] || '',
    CustomerName: order.userLocation?.name || 'No name found',
    Phone: 'Invisible',
    Address: order.userLocation?.address || '',
    Status: order.status || '',
    TotalPrice: order.totalPrice || 0,
    DeliveryCharge: order.charges?.deliveryCharge || 0,
    PackingCharge: order.charges?.packing || 0,
    Tax: order.charges?.tax || 0,
    ServiceCharge: order.charges?.service || 0,
    km:order?.distance||0,
    CreatedAt: order.createdAt ? new Date(order.createdAt).toLocaleString() : '',
  }));

  // Create a worksheet and workbook
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Orders');

  // Export to Excel
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  saveAs(blob, `Orders_${new Date().toISOString().slice(0, 10)}.xlsx`);
};
